export const EdgyShapes = () => (
  <>
    <svg
      viewBox="0 0 345.46 301.97"
      id="edgy-activity-shape"
      data-label="EDGY Activity"
    >
      <path
        d="M25 31a5.92 5.92 0 0 1 5.92-6H220.5a12.24 12.24 0 0 1 9.67 4.74l90.3 116.5a7.74 7.74 0 0 1 0 9.5l-90.3 116.5a12.24 12.24 0 0 1-9.67 4.73H34.07a6.08 6.08 0 0 1-6.07-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="transparent"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-asset-shape"
      data-label="EDGY Asset"
    >
      <path
        d="M25 31a6 6 0 0 1 6-6h239.97a6 6 0 0 1 6 6v239.97a6 6 0 0 1-6 6H31a6 6 0 0 1-6-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-brand-shape"
      data-label="EDGY Brand"
    >
      <path
        d="M25 31a6 6 0 0 1 6-6h239.97a6 6 0 0 1 6 6v239.97a6 6 0 0 1-6 6H31a6 6 0 0 1-6-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-capability-shape"
      data-label="EDGY Capability"
    >
      <path
        d="M276.97 150.98c0 69.58-56.4 126-126 126-69.57 0-125.97-56.42-125.97-126S81.4 25 150.98 25c69.58 0 126 56.4 126 125.98z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-channel-shape"
      data-label="EDGY Channel"
    >
      <path
        d="M25 31a6 6 0 0 1 6-6h239.97a6 6 0 0 1 6 6v239.97a6 6 0 0 1-6 6H31a6 6 0 0 1-6-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-content-shape"
      data-label="EDGY Content"
    >
      <path
        d="M25 31a6 6 0 0 1 6-6h239.97a6 6 0 0 1 6 6v239.97a6 6 0 0 1-6 6H31a6 6 0 0 1-6-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 345.46 301.97"
      id="edgy-journey-shape"
      data-label="EDGY Journey"
    >
      <path
        d="M25 31a5.92 5.92 0 0 1 5.92-6H220.5a12.24 12.24 0 0 1 9.67 4.74l90.3 116.5a7.74 7.74 0 0 1 0 9.5l-90.3 116.5a12.24 12.24 0 0 1-9.67 4.73H34.07a6.08 6.08 0 0 1-6.07-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-object-shape"
      data-label="EDGY Object"
    >
      <path
        d="M25 31a6 6 0 0 1 6-6h239.97a6 6 0 0 1 6 6v239.97a6 6 0 0 1-6 6H31a6 6 0 0 1-6-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="transparent"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-organisation-shape"
      data-label="EDGY Organisation"
    >
      <path
        d="M25 31a6 6 0 0 1 6-6h239.97a6 6 0 0 1 6 6v239.97a6 6 0 0 1-6 6H31a6 6 0 0 1-6-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-outcome-shape"
      data-label="EDGY Outcome"
    >
      <path
        d="M276.97 150.98c0 69.58-56.4 126-126 126-69.57 0-125.97-56.42-125.97-126C25 81.4 81.4 25 150.98 25c69.58 0 126 56.4 126 125.98z"
        stroke="currentColor"
        strokeWidth="10"
        fill="transparent"
      />
    </svg>

    <svg
      viewBox="0 0 291.97 301.97"
      id="edgy-people-shape"
      data-label="EDGY People"
    >
      <g stroke="currentColor" strokeWidth="10" fill="transparent">
        <path d="M95.6 75.4A50.4 50.4 0 0 1 145.97 25a50.4 50.4 0 0 1 50.4 50.4v37.8a50.4 50.4 0 0 1-50.4 50.38 50.4 50.4 0 0 1-50.4-50.4zM38.33 212.82a33.14 33.14 0 0 1 31.87-24.04h151.57a33.14 33.14 0 0 1 31.87 24.04l11.46 40.1a18.86 18.86 0 0 1-18.13 24.05H45a18.86 18.86 0 0 1-18.13-24.04z" />
      </g>
    </svg>

    <svg
      viewBox="0 0 345.46 301.97"
      id="edgy-process-shape"
      data-label="EDGY Process"
    >
      <path
        d="M25 31a5.92 5.92 0 0 1 5.93-6H220.5a12.24 12.24 0 0 1 9.68 4.74l90.28 116.5a7.74 7.74 0 0 1 0 9.5l-90.28 116.5a12.24 12.24 0 0 1-9.68 4.73H34.08a6.08 6.08 0 0 1-6.08-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-product-shape"
      data-label="EDGY Product"
    >
      <path
        d="M25 31a6 6 0 0 1 6-6h239.97a6 6 0 0 1 6 6v239.97a6 6 0 0 1-6 6H31a6 6 0 0 1-6-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-purpose-shape"
      data-label="EDGY Purpose"
    >
      <path
        d="M276.97 150.98c0 69.58-56.4 126-126 126-69.57 0-125.97-56.42-125.97-126S81.4 25 150.98 25c69.58 0 126 56.4 126 125.98z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 345.46 301.97"
      id="edgy-story-shape"
      data-label="EDGY Story"
    >
      <path
        d="M25 31a5.92 5.92 0 0 1 5.92-6H220.5a12.24 12.24 0 0 1 9.67 4.74l90.3 116.5a7.74 7.74 0 0 1 0 9.5l-90.3 116.5a12.24 12.24 0 0 1-9.67 4.73H34.07a6.08 6.08 0 0 1-6.07-6z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>

    <svg
      viewBox="0 0 301.97 301.97"
      id="edgy-task-shape"
      data-label="EDGY Task"
    >
      <path
        d="M276.97 150.98c0 69.58-56.4 126-126 126-69.57 0-125.97-56.42-125.97-126C25 81.4 81.4 25 150.98 25c69.58 0 126 56.4 126 125.98z"
        stroke="currentColor"
        strokeWidth="10"
        fill="currentColor"
      />
    </svg>
  </>
);
